(() => {
  'use strict';
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const q = selector => root.querySelector(selector);
    const qa = selector => [...root.querySelectorAll(selector)];
    const config = JSON.parse(q('[data-lk-extra-config]').textContent);
    const copy = config.copy;
    const route = typeof config.root === 'string' && config.root.startsWith('/') && !config.root.startsWith('//') ? config.root : '/';
    const form = q('[data-lk-extra-form]');
    if (!form) return;
    const add = q('[data-lk-extra-add]');
    const label = q('[data-lk-extra-add-label]');
    const status = q('[data-lk-extra-status]');
    const review = q('[data-lk-extra-review]');
    let busy = false;
    const selected = () => q('input[name="id"]:checked') || q('input[type="hidden"][name="id"]');
    function updateVariant() {
      const variant = selected();
      add.disabled = busy || !variant || variant.disabled;
      label.textContent = busy ? copy.adding : variant && !variant.disabled ? copy.add : copy.soldOut;
      q('[data-lk-extra-price]').textContent = variant?.dataset.price || '';
    }
    qa('input[type="radio"][name="id"]').forEach(input => input.addEventListener('change', () => {
      updateVariant();
      status.textContent = '';
      review.hidden = true;
      const url = new URL(location.href);
      url.searchParams.set('variant', input.value);
      history.replaceState(history.state, '', url);
    }));
    if (config.isBundle) {
      const catalogue = JSON.parse(q('[data-lk-catalog]').textContent);
      const browser = q('[data-lk-browser]');
      const filters = qa('[data-lk-extra-pack]');
      const selectPack = handle => {
        if (!browser?._lkBrowser?.selectPack(handle || null)) return false;
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lkExtraPack === (handle || ''))));
        return true;
      };
      filters.forEach(button => button.addEventListener('click', () => selectPack(button.dataset.lkExtraPack)));
      qa('[data-lk-extra-pack-link]').forEach(link => link.addEventListener('click', () => selectPack(link.dataset.lkExtraPackLink)));
      const quick = q('[data-lk-extra-quick]');
      const chosen = filters.filter(button => button.dataset.lkExtraPack).map(button => catalogue.find(track => track.packHandle === button.dataset.lkExtraPack)).filter(Boolean);
      const buttons = chosen.map(track => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lk-product-quick-row';
        button.setAttribute('aria-label', copy.play.replace('__TITLE__', track.title));
        button.setAttribute('aria-pressed', 'false');
        const icon = document.createElement('span');
        icon.className = 'lk-product-quick-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '▶';
        const name = document.createElement('span');
        name.className = 'lk-product-quick-name';
        name.textContent = track.title;
        const meta = document.createElement('span');
        meta.className = 'lk-product-quick-meta';
        meta.textContent = track.pack;
        button.append(icon, name, meta);
        button.addEventListener('click', () => {
          const selector = `[data-lk-play-id="${CSS.escape(track.id)}"]`;
          if (!q(selector)) selectPack(track.packHandle);
          q(selector)?.click();
        });
        return {button, icon, track};
      });
      quick.replaceChildren(...buttons.map(item => item.button));
      document.addEventListener('lk:audio-state', event => {
        buttons.forEach(({button, icon, track}) => {
          const active = event.detail.playing && event.detail.track?.id === track.id;
          button.setAttribute('aria-pressed', String(Boolean(active)));
          button.setAttribute('aria-label', (active ? copy.pause : copy.play).replace('__TITLE__', track.title));
          icon.textContent = active ? 'Ⅱ' : '▶';
        });
      });
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const variant = selected();
      if (busy || !variant || variant.disabled) return;
      busy = true;
      updateVariant();
      status.textContent = '';
      status.classList.remove('is-error');
      review.hidden = true;
      let confirmed = false;
      try {
        const response = await fetch(route + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(variant.value), quantity: 1}], sections: ['cart-icon-bubble']})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || copy.error);
        confirmed = true;
        if (result.sections?.['cart-icon-bubble']) {
          const documentSection = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          const content = documentSection.querySelector('.shopify-section');
          const target = document.querySelector('#cart-icon-bubble');
          if (content && target) target.innerHTML = content.innerHTML;
        }
        document.dispatchEvent(new Event('cart:updated'));
        status.textContent = copy.added;
        review.hidden = false;
      } catch (error) {
        status.textContent = confirmed ? copy.added : error instanceof TypeError ? copy.uncertain : error.message || copy.error;
        status.classList.toggle('is-error', !confirmed);
        review.hidden = false;
        document.dispatchEvent(new Event('cart:updated'));
      } finally {
        busy = false;
        updateVariant();
      }
    });
    updateVariant();
  }
  const start = () => document.querySelectorAll('[data-lk-extra-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
